import { useIntl } from 'react-intl';

import { LoggedInJiraBlueWaveTemplateExistingUser } from '../components/logged-in-blue-wave-template-jira-existing-user';

export const LoggedInJiraPremiumExistingUser = () => {
	const { formatMessage } = useIntl();

	return (
		<LoggedInJiraBlueWaveTemplateExistingUser
			productEditionText={formatMessage({
				id: 'WacSignupHeader.cloudPremium',
				defaultMessage: 'Cloud Premium',
			})}
		/>
	);
};
